module.exports = __webpack_public_path__ + "static/media/messenger.fa4d8a71.svg";